import React, { Fragment } from 'react'

const GovActionContentWrapper = ({ children }) => (
  <Fragment>
    <div className="govListActions--pointerAlignment">
      <div className="govListActions--pointer" />
    </div>
    <div className="govListActions--content">{children}</div>
  </Fragment>
)
export default GovActionContentWrapper



// WEBPACK FOOTER //
// ./src/ui/gov-actions/views/content-wrapper.jsx